//deps
import React, { memo, ReactElement, useEffect, useMemo, useRef, useState } from "react";

//constants
import { TEXTS } from "@cart-ui/constants";

//helpers
import { getHourMinSecFromDuration, getTimeInFormat } from "@cart-ui/helpers/CouponlessSavings";

interface CouponlessSavingsTimerProps {
    durationInSeconds: number;
    onComplete: () => void;
}

const CouponlessSavingsTimer = (props: CouponlessSavingsTimerProps): ReactElement => {
    const { durationInSeconds, onComplete } = props;
    const [remainingTime, setRemainingTime] = useState(durationInSeconds);
    const timerInterval = useRef<NodeJS.Timeout | undefined | number>();
    const displayTime = useMemo(() => getHourMinSecFromDuration(remainingTime), [remainingTime]);

    useEffect(() => {
        timerInterval.current = setInterval(() => {
            if (remainingTime <= 0) {
                onComplete();
                if (timerInterval.current != null) {
                    clearInterval(timerInterval.current as NodeJS.Timeout);
                }
                return;
            }
            setRemainingTime((prevState) => prevState - 1);
        }, 1000);
        return (): void => {
            if (timerInterval.current != null) {
                clearInterval(timerInterval.current as NodeJS.Timeout);
            }
        };
    }, [onComplete, remainingTime]);

    return (
        <div>
            {TEXTS.ENDS_IN} {getTimeInFormat(displayTime)}
        </div>
    );
};
export default memo(CouponlessSavingsTimer);
